/**
 * AP-17-E — Die Installations-Bausteine liegen einmal, die Worte bleiben bei den Apps.
 *
 * ERP und Stempel-PWA installieren sich technisch identisch; unterschiedlich ist
 * nur, wie das Ding heißt, das da installiert wird — „Symphenia" im ERP, „die
 * App" in der PWA — und wo die Safari-Menüleiste sitzt (am Handy unten, sonst
 * oben). Genau diese Unterschiede stehen hier als Text-Paket; alles andere ist
 * geteilt.
 */
export interface InstallTexts {
  /** In Sätzen: „Installiere **Symphenia** als App…" bzw. „…**die App**…". */
  appName: string
  /**
   * In „Öffne … in Chrome": im ERP der Produktname, in der PWA „diese Seite" —
   * denn dort ist die Seite bereits offen, wenn der Text gelesen wird.
   */
  openTarget?: string
  /** Beschriftung von Knopf und Kopfzeile. */
  installLabel?: string
  /**
   * Auf dem iPhone sitzt die Safari-Menüleiste **unten**, auf iPad und Mac oben.
   * Die PWA läuft praktisch immer am Handy, das ERP praktisch nie.
   */
  shareBarAtBottom?: boolean
}

/** KA-41: „die App" am Satzanfang groß — der Name steht dort, wo ein Satz beginnt. */
export function satzanfang(text: string): string {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text
}

/** Fällt für die optionalen Felder auf sinnvolle Werte zurück. */
export function resolveTexts(texts: InstallTexts) {
  return {
    appName: texts.appName,
    openTarget: texts.openTarget ?? texts.appName,
    installLabel: texts.installLabel ?? `${texts.appName} als App installieren`,
    shareBarAtBottom: texts.shareBarAtBottom ?? false,
  }
}
